(function () {
  function activate(section, index) {
    var triggers = section.querySelectorAll("[data-diamond-trigger]");
    var previews = section.querySelectorAll("[data-diamond-preview]");

    triggers.forEach(function (trigger) {
      trigger.classList.toggle(
        "is-active",
        trigger.getAttribute("data-diamond-trigger") === index,
      );
    });

    previews.forEach(function (preview) {
      preview.classList.toggle(
        "is-active",
        preview.getAttribute("data-diamond-preview") === index,
      );
    });
  }

  function initSection(section) {
    if (section.dataset.zelsuDiamondReady === "true") return;
    section.dataset.zelsuDiamondReady = "true";

    var triggers = section.querySelectorAll("[data-diamond-trigger]");

    triggers.forEach(function (trigger) {
      var index = trigger.getAttribute("data-diamond-trigger");

      trigger.addEventListener("mouseenter", function () {
        activate(section, index);
      });

      trigger.addEventListener("focusin", function () {
        activate(section, index);
      });
    });
  }

  function initAll() {
    document
      .querySelectorAll("[data-zelsu-diamond-showcase]")
      .forEach(initSection);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll);
  } else {
    initAll();
  }

  document.addEventListener("shopify:section:load", function (event) {
    var section = event.target.querySelector("[data-zelsu-diamond-showcase]");
    if (section) initSection(section);
  });
})();
